export function formatPrice(
  price: number,
  locale = 'en-AU',
  options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
) {
  return new Intl.NumberFormat(locale, options).format(price);
}

export function formatAddress({
  address,
  city,
  postCode,
}: {
  address?: string;
  city?: string;
  postCode?: string;
}): string {
  const parsedAddress = address?.split('$$$')[0]?.trim() ?? '';

  return [parsedAddress, city, postCode].filter((part) => !!part && part.trim() !== '').join(', ');
}
